import React from "react";
import { Menu, Dropdown, Avatar } from "antd";
import { connect } from 'react-redux'
import { 
  EditOutlined, 
  SettingOutlined, 
  ShopOutlined, 
  QuestionCircleOutlined,
  WarningOutlined,
  LogoutOutlined 
} from '@ant-design/icons';
import Icon from 'components/util-components/Icon';
import { signOut } from 'redux/actions/Auth';
import { goToBugURL } from "views/app-views/apps/commons";

const menuItem = [/*
	{
		title: "Edit Profile",
		icon: EditOutlined ,
		path: "/"
    },
    
    {
		title: "Account Setting",
		icon: SettingOutlined,
		path: "/"
    },
    {
		title: "Billing",
		icon: ShopOutlined ,
		path: "/"
	},
    {
		title: "Help Center",
		icon: QuestionCircleOutlined,
		path: "/"
	}*/
]

export const NavProfile = ({signOut}) => {
  const primaryData = JSON.parse( localStorage.getItem("PRIMARY_DATA"))
  const profileImg = "/img/avatars/thumb-1.jpg";
  // En sesiones LTI el soporte lo gestiona la mesa de ayuda de la institución,
  // así que ocultamos el ítem "Reportar error". El flag lo setea la saga de Auth
  // en el login LTI (ver src/App.js y LtiWelcomeModal).
  const isLtiSession = sessionStorage.getItem("lti_auto_logout") === "1";
  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">
          <Avatar size={45} src={profileImg} />
          <div className="pl-3">
            <h4 className="mb-0">{primaryData.Nombre}</h4>
            <h5 className="mb-0">{primaryData.Empresa}</h5>
            <span className="text-muted">{primaryData.showRol}</span>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <a href={el.path}>
                  <Icon type={el.icon} />
                  <span className="font-weight-normal">{el.title}</span>
                </a>
              </Menu.Item>
            );
          })}
          {!isLtiSession && (
            <Menu.Item key={menuItem.length + 1} onClick={e => goToBugURL()}>
              <span>
                <WarningOutlined/>
                <span className="font-weight-normal">  Reportar error</span>
              </span>
            </Menu.Item>
          )}
          <Menu.Item key={menuItem.length + 2} onClick={e => signOut()}>
            <span>
              <LogoutOutlined/>
              <span className="font-weight-normal">  Cerrar sesión</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <Menu className="d-flex align-item-center" mode="horizontal">
        <Menu.Item key="profile">
          <Avatar src={profileImg} />
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
}

export default connect(null, {signOut})(NavProfile)
